export default __webpack_public_path__ + "static/media/copy-icon.27f6c811.svg";